module.exports = __webpack_public_path__ + "static/img/4779_phase_function_Paper_PointsHejduk_Prediction.e8d2095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4779_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 9sJU
// module chunks = 0